import React from 'react';
import ReactECharts from 'echarts-for-react';
import { useWeibullChartOptions } from './useWeibullChartOptions';
import { WeibullAnalysisResult } from '@/utils/weibull';
import { CensoredDataPoint } from '@/utils/weibullCensored';
import { ColorByOption, MarkerByOption, SizeByOption } from '@/components/analysis/PlotCustomization';

interface WeibullCDFPlotProps {
  analysis: WeibullAnalysisResult;
  title?: string;
  showConfidenceIntervals?: boolean;
  confidenceLevel?: number;
  showCensoredData?: boolean;
  censoredData?: CensoredDataPoint[];
  height?: number;
  colorBy?: ColorByOption;
  markerBy?: MarkerByOption;
  sizeBy?: SizeByOption;
  showLegend?: boolean;
}

const WeibullCDFPlot: React.FC<WeibullCDFPlotProps> = ({
  analysis,
  title: _title,
  showConfidenceIntervals = true,
  confidenceLevel = 95,
  showCensoredData = false,
  censoredData,
  height: _height = 400,
  colorBy = 'none',
  markerBy = 'none',
  sizeBy = 'uniform',
  showLegend = false,
}) => {
  const options = useWeibullChartOptions({
    analysis,
    showConfidenceIntervals,
    confidenceLevel,
    showCensoredData,
    censoredData,
    chartType: 'cdf',
    colorBy,
    markerBy,
    sizeBy,
    showLegend,
  });

  // Force re-render when confidence intervals change
  const chartKey = React.useMemo(
    () => `cdf-${showConfidenceIntervals}-${confidenceLevel}-${Date.now()}`,
    [showConfidenceIntervals, confidenceLevel]
  );

  return (
    <div className="w-full h-full">
      <ReactECharts
        key={chartKey}
        option={options}
        style={{ height: '100%', width: '100%' }}
        theme="light"
        opts={{ renderer: 'canvas' }}
        notMerge={true}
        lazyUpdate={false}
      />
    </div>
  );
};

export default WeibullCDFPlot;
